import { yupResolver } from "@hookform/resolvers/yup";
import {
  Badge,
  Button,
  Card,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  OutlinedInput,
  Stack,
  Typography,
  Box,
} from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useParams, useNavigate } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import Appbar from "../../components/Appbar";
import Body from "../../components/Body";
import Drawer from "../../components/Drawer";
import Chip from "@mui/material/Chip";
import { subjectEditApi } from "../../store/subject/subjectEdit";
import { subjectAddApi } from "../../store/subject/subjectAdd";
import { subjectDetailsApi, resetsubject } from "../../store/subject/subjectDetail";
import { classGlobalApi } from "../../store/class/classListGlobal";
import { useTheme } from '@mui/material/styles';
import { uploadImageApi } from "../../store/upload/uploadImage";
import { toast } from "react-hot-toast";
import ImageUploading from "react-images-uploading";
import BackdropUI from "../../ui/Backdrop";



const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const schema = yup
  .object({
    title: yup.string().required("Please Provide A category ").trim(),
  })
  .required();

export default function SubjectEdit() {
  const subjectDetails = useSelector((state) => state?.subjectDetails);
  const { result: classList, loading: classLoading } = useSelector((state) => state?.classGlobal);
  const theme = useTheme();
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    watch,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const params = useParams();
  const navigate = useNavigate();
  const subjectAdd = useSelector((state) => state?.subjectAdd);
  const subjectEdit = useSelector((state) => state?.subjectEdit);
  const [images, setImages] = React.useState([]);
  const uploadImage = useSelector((state) => state?.uploadImage);
  const [imageLink, setImageLink] = useState();

  useEffect(() => {
    if (params.id) {
      dispatch(subjectDetailsApi(params.id));
    }
    dispatch(classGlobalApi());
    return () => {
      dispatch(resetsubject())
    }
  }, [dispatch]);

  const handleUpdateForm = async (value) => {
    var newObj;
    if (value.title_hn === '')
      delete value.title_hn
    if (imageLink) {
      newObj = { ...value, image: imageLink };
    } else if (
      images.length > 0 &&
      !uploadImage?.loading &&
      uploadImage.result
    ) {
      newObj = { ...value, icon: uploadImage.result };
    } else {
      toast.error("Please Upload An Image", {
        id: "toast",
        duration: 1000,
        position: "top-center",
      });
      return;
    }
    if (params.id) {
      newObj = { ...newObj, id: params.id };
      await dispatch(subjectEditApi(newObj));
      if (!subjectEdit?.loading) {
        navigate("/subject-management");
      }
    } else {
      await dispatch(subjectAddApi(newObj));
      if (!subjectAdd?.loading) {
        navigate("/subject-management");
      }
    }
  };

  useEffect(() => {
    let defalutValues = {};
    if (params.id) {
      if (subjectDetails.result?.icon) {
        setImageLink(subjectDetails.result?.icon);
      }
      defalutValues["title"] = subjectDetails.result?.title;
      defalutValues["title_hn"] = subjectDetails.result?.title_hn;
      defalutValues["class_ids"] = subjectDetails.result?.classes?.map(o => o?.id);
    }
    reset(defalutValues);
  }, [subjectDetails]);

  const onUploadImage = async (imageList, addUpdateIndex) => {
    if (imageList.length > 0) {
      let formData = new FormData();
      //console.log(imageList, imageList);
      formData.append("file", imageList[0]?.file);
      // await dispatch(uploadImageApi(formData));
      const res = await dispatch(uploadImageApi(formData));
      if (res?.payload?.status === 400) {
        setImages([]);
        return
      }
    }
    setImages(imageList);
  };
  return (
    <>
      <Appbar />
      <Drawer />
      <Body>
        <form onSubmit={handleSubmit(handleUpdateForm)}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Card>
                <Typography>Subject Details</Typography>
                <Stack spacing={2} my={2}>
                  <Divider />

                  <Stack direction="row" spacing={2}>
                    <FormControl variant="outlined" fullWidth>
                      <InputLabel htmlFor="outlined-adornment-category" shrink>
                        Title
                      </InputLabel>
                      <OutlinedInput
                        {...register("title")}
                        label="title"
                        notched
                        id="outlined-adornment-category"
                        error={errors?.title?.message}
                      />
                      <FormHelperText error>
                        {errors?.title?.message}
                      </FormHelperText>
                    </FormControl>

                    <FormControl variant="outlined" fullWidth>
                      <InputLabel htmlFor="outlined-adornment-category" shrink>
                        Title (Hindi)
                      </InputLabel>
                      <OutlinedInput
                        {...register("title_hn")}
                        label="title_hn"
                        notched
                        id="outlined-adornment-category"
                        error={errors?.title_hn?.message}
                      />
                      <FormHelperText error>
                        {errors?.title_hn?.message}
                      </FormHelperText>
                    </FormControl>
                  </Stack>
                  <Stack direction="row" spacing={2}>
                    <FormControl variant="outlined" fullWidth>
                      <InputLabel htmlFor="outlined-adornment-email" shrink>
                        Class
                      </InputLabel>
                      <Controller
                        name="class_ids"
                        control={control}
                        defaultValue={[]}
                        render={({ field }) => (
                          <Select
                            {...field}
                            multiple
                            value={watch('class_ids', [])}
                            onChange={(e) => {
                              const {
                                target: { value },
                              } = e;
                              setValue('class_ids', typeof value === 'string' ? value.split(',') : value);
                              field.onChange(e);
                            }}
                            input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                            renderValue={(selected) => (
                              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                {selected.map((value) => (
                                  <Chip key={value} label={classList.find(obj => obj.id === value)?.title || ""} />
                                ))}
                              </Box>
                            )}
                            MenuProps={MenuProps}
                          >
                            {classList.map((obj) => (
                              <MenuItem
                                key={obj.title}
                                value={obj.id}
                                style={getStyles(obj.title, watch('class_ids', []), theme)}
                              >
                                {obj.title}
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                      />
                      {errors.class_ids && <span>{errors.class_ids.message}</span>}
                      <FormHelperText error>
                        {errors?.class_ids?.message}
                      </FormHelperText>
                    </FormControl>
                  </Stack>

                </Stack>
                <Stack spacing={2} my={2}>
                  <InputLabel>
                    Icon
                  </InputLabel>
                  {imageLink ? (
                    <div className="image-item">
                      <img
                        src={imageLink}
                        alt=""
                        width={320}
                        height={180}
                      />
                      <div className="image-item__btn-wrapper">
                        <Button
                          onClick={() => setImageLink(null)}
                          variant="contained"
                        >
                          Remove
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <ImageUploading
                      // multiple
                      acceptType={['png', 'jpeg', 'jpg', 'svg']}
                      value={images}
                      onChange={onUploadImage}
                      maxNumber={1}
                      dataURLKey="data_url"
                    >
                      {({
                        imageList,
                        onImageUpload,
                        onImageRemoveAll,
                        onImageUpdate,
                        onImageRemove,
                        isDragging,
                        dragProps,
                        errors,
                      }) => (
                        <>
                          <div className="upload__image-wrapper">
                            {imageList.length > 0 ? null : (
                              <Button
                                type="button"
                                variant="contained"
                                style={
                                  isDragging ? { color: "red" } : undefined
                                }
                                onClick={onImageUpload}
                                {...dragProps}
                              >
                                Click or Drop Image here
                              </Button>
                            )}

                            {errors && (
                              <div>
                                {errors.maxNumber && (
                                  <span>
                                    Number of selected images exceed maxNumber
                                  </span>
                                )}
                                {errors.acceptType && (
                                  <span>
                                    Your selected file type is not allow
                                  </span>
                                )}
                                {errors.maxFileSize && (
                                  <span>
                                    Selected file size exceed maxFileSize
                                  </span>
                                )}
                                {errors.resolution && (
                                  <span>
                                    Selected file is not match your desired
                                    resolution
                                  </span>
                                )}
                              </div>
                            )}
                            {imageList.map((image, index) => (
                              <div key={index} className="image-item">
                                <img
                                  src={image["data_url"]}
                                  alt=""
                                  width={320}
                                  height={180}
                                />
                                <div className="image-item__btn-wrapper">
                                  <Button
                                    onClick={() => onImageUpdate(index)}
                                    variant="contained"
                                    sx={{ mr: 2 }}
                                  >
                                    Update
                                  </Button>
                                  <Button
                                    onClick={() => onImageRemove(index)}
                                    variant="contained"
                                  >
                                    Remove
                                  </Button>
                                </div>
                              </div>
                            ))}
                          </div>
                        </>
                      )}
                    </ImageUploading>
                  )}
                </Stack>
              </Card>
              <Button
                type="button"
                sx={{ float: "right", mt: 2, ml: 2 }}
                variant="contained"
                onClick={() => navigate(-1)}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                sx={{ float: "right", mt: 2 }}
                variant="contained"
              >
                {params.id ? "Update" : "Create"}
              </Button>
            </Grid>
          </Grid>
        </form>
      </Body>
      <BackdropUI open={uploadImage?.loading} />
    </>
  );
}
